import React from 'react';
import { deletePhonenumberStock, } from '@Api';
import { IAbilities, IAuth, IOrganizationStore, } from '@Store';
import { CrudEnum, IPreviewPhonenumberStock, PermissionEnum, TPhonenumberStockSortableListCol, } from 'atlas-shared';
import { tableColumnStringSorter, DisplayPhoneNumber, translatePhoneNumber, } from '@Utils';
import { TFunction, } from 'i18next';
import { NavigateFunction, } from 'react-router';
import { ColumnsType, } from 'antd/lib/table/interface';
import { listAuditButton, listCloneButton, listDeleteButton, GetColumnSearchLikeProps, } from '../components';
import { IWithListProps, } from '@Hocs/with.list';

export const PhonenumberStockListColumns = (t: TFunction, navigate: NavigateFunction, showDeleted: boolean, organizations: IOrganizationStore, abilities: IAbilities, auth: IAuth, buttons: Array<(row: IPreviewPhonenumberStock) => React.ReactElement> = [], filters: IWithListProps<IPreviewPhonenumberStock, TPhonenumberStockSortableListCol>['filters'], sorter: IWithListProps<IPreviewPhonenumberStock, TPhonenumberStockSortableListCol>['sorter']): ColumnsType<IPreviewPhonenumberStock> => {
  return [
    {
      title: t('NUMBER'),
      dataIndex: 'number',
      key: 'number',
      render: (number: IPreviewPhonenumberStock['number'], phonenumber_stock: IPreviewPhonenumberStock) => <DisplayPhoneNumber t={t} phonenumber={translatePhoneNumber(number)} />,
      sorter: (a: IPreviewPhonenumberStock, b: IPreviewPhonenumberStock) => tableColumnStringSorter(a.number, b.number),
      sortDirections: ['descend', 'ascend', ],
      sortOrder: sorter.find(s => s.column === 'number')?.order || null,
      filteredValue: filters.number || null,
      ...GetColumnSearchLikeProps(t, 'number', t('NUMBER')),
      className: 'table-cell-number',
    },
    
    {
      title: '',
      dataIndex: 'operation',
      key: 'operation',
      render: (_: any, row: IPreviewPhonenumberStock) => (
        <div className={'table-operation-wrp'}>
          {buttons.map(button => button(row))}
          {abilities.can(null, CrudEnum.Insert, PermissionEnum.PhonenumberStock, row) && listCloneButton(t, navigate, 'phonenumber_stock', row)}
          {abilities.can(null, CrudEnum.Read, PermissionEnum.Audit, row) && listAuditButton(t, navigate, 'phonenumber_stock', row)}
          {row.id && abilities.can(null, CrudEnum.Delete, PermissionEnum.PhonenumberStock, row) && listDeleteButton(t, row, deletePhonenumberStock)}
        </div>
      ),
    },
  ].filter(Boolean) as ColumnsType<IPreviewPhonenumberStock>;

};
